import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FooterLayoutComponent, LoginLayoutComponent } from '.';
import { SidebarLayoutComponent } from './gui-layout/sidebar-layout/sidebar-layout.component';
import { GuiLayoutComponent } from './gui-layout/gui-layout.component';
import { EntitiesModule } from '../entities/entities.module';
import { SharedModule } from '../shared/shared.module';
import { AppRoutingModule } from '../app-routing.module';
import { TopbarLayoutComponent } from './gui-layout/topbar-layout/topbar-layout.component';
import { LoadingModule } from 'ngx-loading';
import { MatSnackBarModule } from '@angular/material';
import { SnackBarComponent } from './gui-layout/sidebar-layout/snack-bar/snack-bar.component';
import { AlertsService } from '../entities/alerts/alerts.service';

@NgModule({
  imports: [
    CommonModule,
    EntitiesModule,
    SharedModule,
    AppRoutingModule,
    LoadingModule,
    MatSnackBarModule
  ],
  declarations: [
    GuiLayoutComponent,
    FooterLayoutComponent,
    SidebarLayoutComponent,
    LoginLayoutComponent,
    TopbarLayoutComponent,
    SnackBarComponent
  ],
  entryComponents: [
    SnackBarComponent
  ],
  exports: [
    GuiLayoutComponent,
    LoginLayoutComponent,
    FooterLayoutComponent,
    SidebarLayoutComponent,
    TopbarLayoutComponent
  ],
  providers: [
    AlertsService
  ]
})
export class LayoutsModule { }



// WEBPACK FOOTER //
// ./src/app/layouts/layouts.module.ts